const botpress_session = (state = null, action) => {
  switch (action.type) {
    case "SET_BOTPRESS_SESSION":
      return action.payload;
    default:
      return state;
  }
};

export default botpress_session;
